import React from 'react';
import { Icon } from 'antd';
import VBQLArea from '../../views/VBQLArea';
import Button from '../../views/StyledButton';
import SchemaMenu from './SchemaMenu';
import FieldButtons from '../../views/FieldButtons';
import DateRangeModal from "../Query/DateRangeModal";


export default class QueryTabWhere extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateModalVisible: false,
    };

    this.setDateModalVisible = this.setDateModalVisible.bind(this);
    this.addDateRangeToWhere = this.addDateRangeToWhere.bind(this);
  }

  setDateModalVisible(isVisible) {
    console.log('######### setDateModalVisible clicked');
    this.setState({
      dateModalVisible: isVisible,
    });
  }

  addDateRangeToWhere(dateStrings) {
    const startDate = dateStrings[0] + "T00:00:00.000Z",
      endDate = dateStrings[1] + "T00:00:00.000Z";
    let dateRangeString = '(dateCreated >= "' + startDate + '" AND dateCreated <= "' + endDate + '")';
    this.props.addWhereField(dateRangeString);
  }

  render() {
    const {
      schemaMenuClick, schema, addWhereField,
      chooseQueryWhere, queryModel
    } = this.props;
    return (
      <>
        <FieldButtons className="field-buttons">
          <div>
        <span className="add-button">
          <SchemaMenu
            root={schema}
            type="where"
            onClick={(item, advanced) => {
              schemaMenuClick(item, 'where', advanced);
            }}
          />
        </span>
          </div>
          <div>
            <div className="search-field-button">
              <Button type="default" size="small" onClick={() => addWhereField('* says {"Phrase_to_search_for"}')}>
                <Icon
                  type="search"
                />
                Search
              </Button>
            </div>
          </div>
          <div>
            <div className="search-field-button">
              <Button type="default" size="small" onClick={() => this.setDateModalVisible(true)}>
                <Icon
                  type="calendar"
                />
                Date
              </Button>
            </div>
          </div>
        </FieldButtons>
        <div className="cm-size-150">
          {<VBQLArea
            placeholder="enter the 'WHERE' part of your query"
            value={queryModel.where}
            onChange={chooseQueryWhere}
          />}
        </div>
        <DateRangeModal dateModalVisible={this.state.dateModalVisible} setDateModalVisible={this.setDateModalVisible} addDateRangeToWhere={this.addDateRangeToWhere} />
      </>
    );
  }
}
